module.exports = __webpack_public_path__ + "static/Bottom-backg@2x-c14fa84aa46b3cb8e3caf1b5df9030e2.png";